import { render, staticRenderFns } from "./goldenSentence.vue?vue&type=template&id=2e98cf9b&scoped=true&"
import script from "./goldenSentence.vue?vue&type=script&lang=js&"
export * from "./goldenSentence.vue?vue&type=script&lang=js&"
import style0 from "./goldenSentence.vue?vue&type=style&index=0&id=2e98cf9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e98cf9b",
  null
  
)

export default component.exports